import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { connect } from 'react-redux';

@connect((store) => {
    return { user: store.user, siteMaster: store.siteMaster }
})
export default class IncLboDisconnect extends React.Component {

    render() {
        return <div>
            <h4 className="mar-b25">Really Disconnect?</h4>
            <div className="mar-b25">Are you sure you want to disconnect Little Box Office from {this.props.siteMaster.siteName}?</div>
            <div className="mar-b25">Your contacts will remain in Transpond but we will stop syncing with Little Box Office.</div>
            <Button text="Disconnect!" className="button-primary" onClick={this.props.goDisconnect} />
        </div>
    }
};
